import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import printPdf from 'utils/printPdf';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import IconButton from 'components/common/IconButton';
import IconArrowHeadLeft from 'components/icons/IconArrowHeadLeft';
import IconArrowHeadRight from 'components/icons/IconArrowHeadRight';

import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import IconCrossBold from 'components/icons/IconCrossBold';
import IconDownload from 'components/icons/IconDownload';
import IconSave from 'components/icons/IconSave';
import IconPrint from 'components/icons/IconPrint';

import { downloadPatientDocument, getPatientDocument } from 'redux/modules/patientsDocuments';
import { addPatientResource } from 'redux/modules/patients';
import { addNotification } from 'redux/modules/notifications';

import DocumentsViewPdf from './DocumentsViewPdf';
import DocumentsViewImage from './DocumentsViewImage';
import DocumentsViewDefault from './DocumentsViewDefault';
import color from '@material-ui/core/colors/amber';

const styles = theme => ({
  button: {
    color: 'inherit',
    '& + $button': {
      marginLeft: 5,
    },
  },
  iconDownload: {
    width: 14,
    height: 17,
  },
  iconCrossBold: {
    width: 16,
    height: 16,
  },
  documentsView: {
    height: 'calc(100vh - 64px)',
    padding: '20px 0',
  },
  viewGrid: {
    height: '100%',
  },
  controlGrid: {
    textAlign: 'center',
  },
  prevNextButton: {
    color: theme.palette.common.white,
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.grey[600],
    },
  },
  iconArrowHead: {
    width: 20,
    height: 32,
  },
  iconPrint: {
    width: 19,
    height: 18,
    color: theme.palette.common.white,
  },
  dialogTitle: {
    position: 'relative',
  },
  typographyTitle: {
    width: '42%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '60%',
    },
  },
  controls: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginTop: -24,
    transform: 'translateX(-50%)',
    [theme.breakpoints.down('sm')]: {
      left: '70%',
    },
  },
  iconSave: {
    position: 'relative',
    bottom: -1,
    width: 20,
    height: 20,
  },
});

class DocumentsViewDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentDocumentID: null,
    };

    this.onDialogEnter = this.onDialogEnter.bind(this);
    this.onPrevButtonClick = this.onPrevButtonClick.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
  }

  onDialogEnter() {
    const { initialDocumentID, actions } = this.props;
    if (!this.props.Documents[0]['File Url']) {
      this.props.Documents.forEach(documentsItem => {
        actions.getPatientDocument({ ID: documentsItem.ID });
      });   
    }
    this.setState({ currentDocumentID: initialDocumentID });
  }

  onPrevButtonClick() {
    const { Documents } = this.props;
    const { currentDocumentID } = this.state;
    const currentIndex = Documents.findIndex(item => item.ID === currentDocumentID);
    let nextDocumentID;
    if (currentIndex === -1) {
      nextDocumentID = Documents[0].ID;
    } else if (currentIndex === 0) {
      nextDocumentID = Documents[Documents.length - 1].ID;
    } else {
      nextDocumentID = Documents[currentIndex - 1].ID;
    }
    this.setState({ currentDocumentID: nextDocumentID });
  }

  onNextButtonClick() {
    const { Documents } = this.props;
    const { currentDocumentID } = this.state;
    const currentIndex = Documents.findIndex(item => item.ID === currentDocumentID);
    let nextDocumentID;
    if (currentIndex === -1) {
      nextDocumentID = Documents[0].ID;
    } else if (currentIndex === Documents.length - 1) {
      nextDocumentID = Documents[0].ID;
    } else {
      nextDocumentID = Documents[currentIndex + 1].ID;
    }
    this.setState({ currentDocumentID: nextDocumentID });
  }

  render() {
    const {
      Documents,
      classes,
      onClose,
      actions,
      initialDocumentID,
      patient,
      ...otherProps
    } = this.props;
    const currentDocumentID = this.state.currentDocumentID || initialDocumentID;
    const currentDocument = Documents.find(item => item.ID === currentDocumentID);
    let href;
    let src;
    let CurrentDocumentView;
    let printButtonDisabled = true;
    if (currentDocument && currentDocument['File Url']) {
      href = process.env.REACT_APP_API_ROOT
        ? `${process.env.REACT_APP_API_ROOT}${currentDocument['File Url']}${currentDocument['File Name']}`
        : `${currentDocument['File Url']}${currentDocument['File Name']}`;
      src = process.env.REACT_APP_API_ROOT
        ? `${process.env.REACT_APP_API_ROOT}${currentDocument['File Url']}${currentDocument['File Name']}`
        : `${currentDocument['File Url']}${currentDocument['File Name']}`;
      switch (currentDocument['File Type']) {
        case 'application/pdf':
          CurrentDocumentView = (
            <DocumentsViewPdf
              src={src}
            />
          );
          break;
        case 'image/jpeg':
        case 'image/png':
          CurrentDocumentView = (
            <DocumentsViewImage
              src={src}
              alt={currentDocument['File Name']}
            />
          );
          break;
        default:
          CurrentDocumentView = (
            <DocumentsViewDefault
              src={src}
              extension={currentDocument['File Name'].split('.').slice(-1)[0]}
            />
          );
      }
      printButtonDisabled = ['application/pdf', 'image/jpeg', 'image/png']
        .indexOf(currentDocument['File Type']) === -1;
    }
    return (
      <Dialog
        onClose={onClose}
        onEnter={this.onDialogEnter}
        {...otherProps}
        fullScreen
      >
        <DialogTitle className={classes.dialogTitle} fullScreen>
          <Typography
            className={classes.typographyTitle}
            variant="subheading"
            color="inherit"
          >
            {currentDocument ? currentDocument['File Name'] : ''}
          </Typography>
          <div className={classes.controls}>
            <IconButton
              className={classes.button}
              tooltipContent="Print"
              disabled={printButtonDisabled}
              onClick={() => {
                printPdf(href);
              }}
            >
              <IconPrint className={classes.iconPrint} />
            </IconButton>
            <IconButton
              className={classes.button}
              tooltipContent="Download"
              onClick={() => {
                actions.downloadPatientDocument({ href });
              }}
            >
              <IconDownload className={classes.iconDownload} />
            </IconButton>
            {(patient && patient['Record Number']) &&
              <IconButton
                className={classes.button}
                tooltipContent="Save in Chart Documents"
                onClick={() => {
                  actions.addPatientResource({
                    'Record Number': patient['Record Number'],
                    'Document ID': [currentDocument.ID],
                    resolve: () => {
                      actions.addNotification({
                        message: 'File was successfully saved in Chart Documents',
                        variant: 'success',
                      });
                    },
                    reject: () => {
                      actions.addNotification({
                        message: 'Failed to save file in Chart Documents',
                        variant: 'warning',
                      });
                    },
                  });
                }}
              >
                <IconSave className={classes.iconSave} />
              </IconButton>
            }
          </div>
          <IconButton
            onClick={onClose}
            className={classes.button}
            tooltipContent="Close"
          >
            <IconCrossBold className={classes.iconCrossBold} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          fullScreen
        >
          <Grid
            className={classes.documentsView}
            container
            alignItems="center"
            justify="space-between"
            spacing={0}
          >
            <Grid
              item
              xs={2}
              className={classes.controlGrid}
            >
              {Documents.length > 1 &&
                <IconButton
                  className={classes.prevNextButton}
                  onClick={this.onPrevButtonClick}
                  tooltipContent="Previous Document"
                >
                  <IconArrowHeadLeft className={classes.iconArrowHead} />
                </IconButton>
              }
            </Grid>
            <Grid
              item
              xs={7}
              className={classes.viewGrid}
            >
              {CurrentDocumentView}
            </Grid>
            <Grid
              item
              xs={2}
              className={classes.controlGrid}
            >
              {Documents.length > 1 &&
                <IconButton
                  className={classes.prevNextButton}
                  onClick={this.onNextButtonClick}
                  tooltipContent="Next Document"
                >
                  <IconArrowHeadRight className={classes.iconArrowHead} />
                </IconButton>
              }
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

DocumentsViewDialog.propTypes = {
  Documents: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'File Name': PropTypes.string,
    'File Url': PropTypes.string,
  })).isRequired,
  initialDocumentID: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  actions: PropTypes.shape({
    downloadPatientDocument: PropTypes.func.isRequired,
    addPatientResource: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    iconDownload: PropTypes.string.isRequired,
    iconCrossBold: PropTypes.string.isRequired,
    documentsView: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsViewDialog.defaultProps = {
  open: false,
  onClose: () => {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    downloadPatientDocument,
    getPatientDocument,
    addPatientResource,
    addNotification,
  }, dispatch),
});


export default connect(null, mapDispatchToProps)(
  withStyles(styles)(DocumentsViewDialog),
);



// WEBPACK FOOTER //
// ./src/components/common/DocumentsViewDialog/DocumentsViewDialog.js